export default {
  data () {
    return {
      fields: [
        {
          prop: 'id',
          label: 'ID',
          width: 80,
        },
        {
          prop: 'creator_name',
          label: '创建人',
          width: 120,
        },
        {
          prop: 'department_name',
          label: '创建人部门',
          minWidth: 120,
          formatter: row => row.department_name
        },
        {
          prop: 'payment_company_name',
          label: '付款公司',
          minWidth: 90,
        },
        {
          prop: 'apply_payment_type_name',
          label: '付款类型',
          minWidth: 120,
          formatter: row => '付款退款',
        },
        {
          prop: 'refund_desc',
          label: '退款说明',
          minWidth: 150,
        },
        {
          prop: 'refund_amount_total',
          label: '退款金额',
          minWidth: 90,
        },
        {
          prop: 'status',
          label: '付款状态',
          width: 123,
          formatter: row => '已退款',
        },
        {
          prop: 'created_at',
          label: '创建日期',
          width: 160,
        },
        {
          prop: 'refund_date',
          label: '退款日期',
          width: 130,
          formatter: this.formatterRefundDate
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      paymentCompanys: state => state.paymentManager.paymentCompanys,
    }),
  },
  methods: {
    formatterRefundDate (row) {
      if (row.refund_date !== '0000-00-00 00:00:00') {
        return row.refund_date.substr(0, 10)
      }
      return '-'
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/payment-refund/payment-refund.mixins.js